import React from "react";
import { TestID } from "../../shared/testids/testids";
import { ThemeSetting, useTheme } from "../../theme/ThemeProvider";
import { UserPreference } from "../../shared/customHoooks/useUserConfig";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { COREMenuItem } from "../Navigation/COREMenuItem";
import { COREIcon } from "../Content/COREIcon";

export const ThemeMenuItem: React.FC<{ testID: TestID }> = ({ testID }) => {
  const { theme, changeTheme } = useTheme();

  const themeOrder: UserPreference["theme"][] = [
    "default",
    "light",
    "dark",
    "device",
  ];

  const getBaseTheme = (t: string): UserPreference["theme"] => {
    if (t.startsWith("device-")) return "device";
    if (["default", "light", "dark", "device"].includes(t))
      return t as ThemeSetting;
    return "default";
  };

  const nextTheme = () => {
    const baseTheme = getBaseTheme(theme);
    const idx = themeOrder.indexOf(baseTheme);
    const nextIdx = idx === -1 ? 0 : (idx + 1) % themeOrder.length;
    changeTheme(themeOrder[nextIdx]);
  };

  const themeIcons: Record<string, any> = {
    default: icon({ name: "circles-overlap", style: "regular" }),
    light: icon({ name: "sun", style: "regular" }),
    dark: icon({ name: "moon", style: "regular" }),
    device: icon({ name: "desktop", style: "regular" }),
    "device-light": icon({ name: "desktop", style: "regular" }),
    "device-dark": icon({ name: "desktop", style: "regular" }),
  };

  const themeLabels: Record<string, string> = {
    default: "Default",
    light: "Light",
    dark: "Dark",
    device: "Device",
    "device-light": "Device",
    "device-dark": "Device",
  };

  return (
    <COREMenuItem
      key={"theme"}
      icon={
        <COREIcon
          icon={
            themeIcons[theme] ??
            icon({ name: "circles-overlap", style: "regular" })
          }
        />
      }
      testID={testID}
      onClick={nextTheme}
    >
      {themeLabels[theme] ?? "Default"} theme
    </COREMenuItem>
  );
};
